import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { setHeight } from '../../store/navigation';
import { IOfferCardAsideDispatchProps, IOfferCardAsideStoreProps, OfferCardAside } from './index';

function mapStateToProps(state: IState): IOfferCardAsideStoreProps {
  return {
    height: state.aside.height,
    isNavigationActive: state.aside.isNavigationActive,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IOfferCardAsideDispatchProps {
  return {
    setHeight: (height: number) => dispatch(setHeight(height)),
  };
}

export const OfferCardAsideContainer = connect<IOfferCardAsideStoreProps, IOfferCardAsideDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferCardAside);
